//sticky atc
function changeActive(selected){
    let stickyLabels = document.getElementsByClassName('sticky-atc__label')
    let labelFor = selected.getAttribute('data-for')
    let labelSync = selected.getAttribute('data-sync')
    let labelInner = selected.innerText
    for (let a = 0; a < stickyLabels.length; a++ ){
        stickyLabels[a].classList.remove('selected')
    }
    selected.classList.add('selected');
    

    let aa = document.querySelector('.' + labelSync);
    if (aa !== null) {
    document.querySelector('.' + labelSync).click();
    } else {
      document.querySelector('#' + labelFor).click();
    }

    document.querySelectorAll('.pdp-hero-variant-price:not([data-variant-title="'+labelInner+'"])').forEach(title => {
      title.style.display = 'none'
    });
    document.querySelector('.pdp-hero-variant-price[data-variant-title="'+labelInner+'"]').style.display = 'block';

    try{
      setTimeout(function(){
        document.querySelector('[data-price-wrapper-sticky] [data-product-price]').innerHTML = document.querySelector('[data-main-product-form] [data-price-wrapper] [data-product-price]').innerHTML;
        if(document.querySelector('[data-main-product-form] [data-price-wrapper] [data-compare-price]').innerHTML == ""){
          document.querySelector('[data-price-wrapper-sticky] [data-compare-price]').style="display: none;";
        }
        else{
          document.querySelector('[data-price-wrapper-sticky] [data-compare-price]').style="display: initial;";
          document.querySelector('[data-price-wrapper-sticky] [data-compare-price]').innerHTML = document.querySelector('[data-main-product-form] [data-price-wrapper] [data-compare-price]').innerHTML;
        }
      }, 100)
    } catch {
      console.log("price doesn't exist")
    }
}
jQuery(document).ready(function(){
$('[data-options] label').click(function(){
  var forr = $(this).attr('for');
  $('.sticky-atc__label[data-for="'+forr+'"]').eq(0).click();
}); 
});
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
document.addEventListener('DOMContentLoaded', function(){
      document.querySelector('#sticky-atc').insertAdjacentHTML("afterend", '<style>.show-sticky{display: none;}</style>')
})


function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId= setTimeout(function(){
      method();
  }, delay);
}

//code for sticky atc
function isInViewport (el) {
  let rect = el.getBoundingClientRect();

  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}

var lastScrollTop = 0;
document.addEventListener("scroll", function(){
   var st = window.pageYOffset || document.documentElement.scrollTop;
   if (st > lastScrollTop){
        document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed')
        document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed-top')
   } else {
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed')
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed-top')
   }
   lastScrollTop = st <= 0 ? 0 : st;
}, false);
